import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { langHelper } from "../../utils/helpers";

import heroImg from "../../images/pricelist-banner.jpg";
import heroImg2x from "../../images/pricelist-banner@2x.jpg";
import "./Confirm.scss";
const translate = {
  thx_01: {
    en: "Thank you",
    nl: "Dank je!"
  },
  thx_02: {
    en: "We will deliver your clean laundry soon",
    nl: "We bezorgen je schone was snel"
  }
}
const { thx_01, thx_02 } = translate;

const Thankyou = props => {
  const lang = langHelper(props);

  return (
    <div className="confirm-page-wrapper">
      {props.wv && (
        <Header wv={props.wv} heroImg={heroImg} heroImg2x={heroImg2x} />
      )}
      <main className="confirm-main">
        <h1>{thx_01[lang]}</h1>
        <p>{thx_02[lang]}</p>
      </main>
      <Footer wv={props.wv} />
    </div>
  );
};

const mapStateToProps = ({ webView }) => ({ wv: webView });

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Thankyou);
